import { createFileRoute, redirect } from '@tanstack/react-router'
import { SEARCH_PARAM_UNIT_ID } from 'routes/(common_search_params)/-searchParams'
import { SEARCH_PARAM_SITE_ID } from 'routes/(global_search_params)/-searchParams'
import { SEARCH_PARAM_ASSET_LENS_TAB } from 'routes/asset-lens/-searchParams'
import { Route as NewRoute } from 'routes/asset-lens/index'
import { z } from 'zod'

const searchSchema = z.object({
  [SEARCH_PARAM_ASSET_LENS_TAB]: z.string().optional(),
})

export const Route = createFileRoute(
  '/asset-lens/(deprecated_routes)/$siteID/$unitID'
)({
  validateSearch: searchSchema,
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: NewRoute.to,
      search: {
        [SEARCH_PARAM_ASSET_LENS_TAB]: search.tab,
        [SEARCH_PARAM_SITE_ID]: params.siteID,
        [SEARCH_PARAM_UNIT_ID]: params.unitID,
      },
    })
  },
})
